import * as React from "react";
import * as ReactDOM from "react-dom/client";

import "./styles.css";
import VehicleStockApp from "./vehicle-stocks-app";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<VehicleStockApp />);
